import request from "@/utils/request";
import axios from 'axios';

const CancelToken = axios.CancelToken;

const initObsConfig = (options) => {
  // const appCode = options.appCode || 'franchiser-api';
  let obsSubDir = options.obsSubDir || '';
  if (obsSubDir.length > 0) {
    if (obsSubDir && obsSubDir.indexOf('/') === 0) {
      /* 前面去掉/  */
      obsSubDir = obsSubDir.substring(1);
    }
    if (obsSubDir.lastIndexOf('/') !== obsSubDir.length - 1) {
      /* 末尾去掉加/  */
      obsSubDir = obsSubDir + '/';
    }
  }
  if (options.file.name.indexOf('#') >= 0 || options.file.name.indexOf('+') >= 0) {
    alert('上传文件名包含特殊符号:#+');
    return;
  }
  const randomKey = getRandomNum();
  const timeStr = getTimeStr();
  let objectName = `${obsSubDir}${randomKey}_${timeStr}_${options.file.name}`;
  objectName = objectName.replace(/\s*/g, '');
  const arr = objectName.split('.');
  objectName = arr[arr.length - 1];
  // const bodyFormData = new FormData();
  // bodyFormData.append('appCode', appCode);
  // bodyFormData.append('fileExtensionList', objectName);
  const baseApi = navigator.userAgent?.includes('cottiCoffee') ? '/cotti-capi' : '/teacat-capi'
  console.log()
  const obsReq = {
    url: baseApi + '/common/sys/base/batch/uploadAuth',
    method: 'POST',
    headers: {
      fileContentType: getContentType(options.file.name),
      'x-obs-acl': 'public-read',
      'Content-Type': 'multipart/form-data'
    },
    data: {
      fileExtensionList: [objectName]
    }
  };
  obsReq.loading = false;
  options.objectName = objectName;
  return request(obsReq);
};

/**
 * 返回结果包装
 * @param result 结果
 * @returns {{bucket: *, versionId: *, fileName: *, requestId: *, Id2: *, domain: *, filePath: string, contentLength: *, key: *, status: number}}
 */
const pkgResult = (result, options) => {
  return {
    status: result.status,
    filePath: options.filePath
  };
};
export function obsUpload(options) {
  const source = CancelToken.source();
  const promise = new Promise(function (resolve, reject) {
    initObsConfig(options).then((res) => {
      res = res.data?.[0];
      res.objectName = options.objectName;
      doPut(
        res.signUrl,
        options.file,
        res.formParams,
        options,
        source
      ).then(function (result) {
        if (result.status < 300) {
          resolve(pkgResult(result, res));
        } else {
          reject(result);
        }
      }).catch(error => {
        reject(error);
      });
    }).catch(error => {
      reject(error);
    });
  });
  promise.abort = () => {
    source.cancel('用户取消了请求');
  };
  return promise;
}

function doPut(_url, file, headers, options, source) {
  delete headers['Host'];
  const bodyFormData = new FormData();
  bodyFormData.append('signature', headers.signature);
  bodyFormData.append('key', headers.key);
  bodyFormData.append('token', headers.token);
  bodyFormData.append('policy', headers.policy);
  bodyFormData.append('content', file);
  const req = {
    method: 'POST',
    url: _url,
    data: bodyFormData,
    onUploadProgress: (progressEvent) => {
      if (typeof options.onProgress == 'function') {
        const progress = {
          percent: (progressEvent.loaded * 100.0) / progressEvent.total,
          transferredAmount: progressEvent.loaded,
          totalAmount: progressEvent.total,
          totalSeconds: progressEvent.timeStamp / 1000
        };
        options.onProgress(progress);
      }
    },
    cancelToken: source.token
  };
  return axios.request(req);
}

/**
 * 获取随机数
 * @returns {string}
 */
const getRandomNum = () => {
  let num = '';
  for (let i = 0; i < 4; i++) {
    num += Math.floor(Math.random() * 10);
  }
  return num;
};

const getTimeStr = () => {
  return new Date().getTime();
};

const getDomain = (url) => {
  const domain = 'https://';
  const str = url.substring(domain.length);
  return domain + str.substring(0, str.indexOf('/'));
};

// 获取 .后缀名
const getExtension = function (filename) {
  if (filename.lastIndexOf('.') < 0) {
    return filename;
  }
  return filename.substring(filename.lastIndexOf('.'));
};

const getContentType = function (filename) {
  const c = new Map();
  c.set('.load', 'text/html');
  c.set('.adb', 'text/x-adasrc');
  c.set('.ads', 'text/x-adasrc');
  c.set('.afm', 'application/x-font-afm');
  c.set('.ag', 'image/x-applix-graphics');
  c.set('.ai', 'application/illustrator');
  c.set('.aif', 'audio/x-aiff');
  c.set('.aifc', 'audio/x-aiff');
  c.set('.aiff', 'audio/x-aiff');
  c.set('.al', 'application/x-perl');
  c.set('.alz', 'application/x-alz');
  c.set('.amr', 'audio/amr');
  c.set('.ani', 'application/x-navi-animation');
  c.set('.anim[1-9j]', 'video/x-anim');
  c.set('.anx', 'application/annodex');
  c.set('.ape', 'audio/x-ape');
  c.set('.arj', 'application/x-arj');
  c.set('.arw', 'image/x-sony-arw');
  c.set('.as', 'application/x-applix-spreadsheet');
  c.set('.asc', 'text/plain');
  c.set('.asf', 'video/x-ms-asf');
  c.set('.asp', 'application/x-asp');
  c.set('.ass', 'text/x-ssa');
  c.set('.asx', 'audio/x-ms-asx');
  c.set('.atom', 'application/atom+xml');
  c.set('.au', 'audio/basic');
  c.set('.avi', 'video/x-msvideo');
  c.set('.aw', 'application/x-applix-word');
  c.set('.awb', 'audio/amr-wb');
  c.set('.awk', 'application/x-awk');
  c.set('.axa', 'audio/annodex');
  c.set('.axv', 'video/annodex');
  c.set('.bak', 'application/x-trash');
  c.set('.bcpio', 'application/x-bcpio');
  c.set('.bdf', 'application/x-font-bdf');
  c.set('.bib', 'text/x-bibtex');
  c.set('.bin', 'application/octet-stream');
  c.set('.blend', 'application/x-blender');
  c.set('.blender', 'application/x-blender');
  c.set('.bmp', 'image/bmp');
  c.set('.bz', 'application/x-bzip');
  c.set('.bz2', 'application/x-bzip');
  c.set('.c', 'text/x-csrc');
  c.set('.c++', 'text/x-c++src');
  c.set('.cab', 'application/vnd.ms-cab-compressed');
  c.set('.cb7', 'application/x-cb7');
  c.set('.cbr', 'application/x-cbr');
  c.set('.cbt', 'application/x-cbt');
  c.set('.cbz', 'application/x-cbz');
  c.set('.cc', 'text/x-c++src');
  c.set('.cdf', 'application/x-netcdf');
  c.set('.cdr', 'application/vnd.corel-draw');
  c.set('.cer', 'application/x-x509-ca-cert');
  c.set('.cert', 'application/x-x509-ca-cert');
  c.set('.cgm', 'image/cgm');
  c.set('.chm', 'application/x-chm');
  c.set('.chrt', 'application/x-kchart');
  c.set('.class', 'application/x-java');
  c.set('.cls', 'text/x-tex');
  c.set('.cmake', 'text/x-cmake');
  c.set('.cpio', 'application/x-cpio');
  c.set('.cpio.gz', 'application/x-cpio-compressed');
  c.set('.cpp', 'text/x-c++src');
  c.set('.cr2', 'image/x-canon-cr2');
  c.set('.crt', 'application/x-x509-ca-cert');
  c.set('.crw', 'image/x-canon-crw');
  c.set('.cs', 'text/x-csharp');
  c.set('.csh', 'application/x-csh');
  c.set('.css', 'text/css');
  c.set('.cssl', 'text/css');
  c.set('.csv', 'text/csv');
  c.set('.cue', 'application/x-cue');
  c.set('.cur', 'image/x-win-bitmap');
  c.set('.cxx', 'text/x-c++src');
  c.set('.d', 'text/x-dsrc');
  c.set('.dar', 'application/x-dar');
  c.set('.dbf', 'application/x-dbf');
  c.set('.dc', 'application/x-dc-rom');
  c.set('.dcl', 'text/x-dcl');
  c.set('.dcm', 'application/dicom');
  c.set('.dcr', 'image/x-kodak-dcr');
  c.set('.dds', 'image/x-dds');
  c.set('.deb', 'application/x-deb');
  c.set('.der', 'application/x-x509-ca-cert');
  c.set('.desktop', 'application/x-desktop');
  c.set('.dia', 'application/x-dia-diagram');
  c.set('.diff', 'text/x-patch');
  c.set('.divx', 'video/x-msvideo');
  c.set('.djv', 'image/vnd.djvu');
  c.set('.djvu', 'image/vnd.djvu');
  c.set('.dng', 'image/x-adobe-dng');
  c.set('.doc', 'application/msword');
  c.set('.docbook', 'application/docbook+xml');
  c.set(
    '.docm',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  );
  c.set(
    '.docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  );
  c.set('.dot', 'text/vnd.graphviz');
  c.set('.dsl', 'text/x-dsl');
  c.set('.dtd', 'application/xml-dtd');
  c.set('.dtx', 'text/x-tex');
  c.set('.dv', 'video/dv');
  c.set('.dvi', 'application/x-dvi');
  c.set('.dvi.bz2', 'application/x-bzdvi');
  c.set('.dvi.gz', 'application/x-gzdvi');
  c.set('.dwg', 'image/vnd.dwg');
  c.set('.dxf', 'image/vnd.dxf');
  c.set('.e', 'text/x-eiffel');
  c.set('.egon', 'application/x-egon');
  c.set('.eif', 'text/x-eiffel');
  c.set('.el', 'text/x-emacs-lisp');
  c.set('.emf', 'image/x-emf');
  c.set('.emp', 'application/vnd.emusic-emusic_package');
  c.set('.ent', 'application/xml-external-parsed-entity');
  c.set('.eps', 'image/x-eps');
  c.set('.eps.bz2', 'image/x-bzeps');
  c.set('.eps.gz', 'image/x-gzeps');
  c.set('.epsf', 'image/x-eps');
  c.set('.epsf.bz2', 'image/x-bzeps');
  c.set('.epsf.gz', 'image/x-gzeps');
  c.set('.epsi', 'image/x-eps');
  c.set('.epsi.bz2', 'image/x-bzeps');
  c.set('.epsi.gz', 'image/x-gzeps');
  c.set('.epub', 'application/epub+zip');
  c.set('.erl', 'text/x-erlang');
  c.set('.es', 'application/ecmascript');
  c.set('.etheme', 'application/x-e-theme');
  c.set('.etx', 'text/x-setext');
  c.set('.exe', 'application/x-ms-dos-executable');
  c.set('.exr', 'image/x-exr');
  c.set('.ez', 'application/andrew-inset');
  c.set('.f', 'text/x-fortran');
  c.set('.f90', 'text/x-fortran');
  c.set('.f95', 'text/x-fortran');
  c.set('.fb2', 'application/x-fictionbook+xml');
  c.set('.fig', 'image/x-xfig');
  c.set('.fits', 'image/fits');
  c.set('.fl', 'application/x-fluid');
  c.set('.flac', 'audio/x-flac');
  c.set('.flc', 'video/x-flic');
  c.set('.fli', 'video/x-flic');
  c.set('.flv', 'video/x-flv');
  c.set('.flw', 'application/x-kivio');
  c.set('.fo', 'text/x-xslfo');
  c.set('.for', 'text/x-fortran');
  c.set('.g3', 'image/fax-g3');
  c.set('.gb', 'application/x-gameboy-rom');
  c.set('.gba', 'application/x-gba-rom');
  c.set('.gcrd', 'text/directory');
  c.set('.ged', 'application/x-gedcom');
  c.set('.gedcom', 'application/x-gedcom');
  c.set('.gen', 'application/x-genesis-rom');
  c.set('.gf', 'application/x-tex-gf');
  c.set('.gg', 'application/x-sms-rom');
  c.set('.gif', 'image/gif');
  c.set('.glade', 'application/x-glade');
  c.set('.gmo', 'application/x-gettext-translation');
  c.set('.gnc', 'application/x-gnucash');
  c.set('.gnd', 'application/gnunet-directory');
  c.set('.gnucash', 'application/x-gnucash');
  c.set('.gnumeric', 'application/x-gnumeric');
  c.set('.gnuplot', 'application/x-gnuplot');
  c.set('.gp', 'application/x-gnuplot');
  c.set('.gpg', 'application/pgp-encrypted');
  c.set('.gplt', 'application/x-gnuplot');
  c.set('.gra', 'application/x-graphite');
  c.set('.gsf', 'application/x-font-type1');
  c.set('.gsm', 'audio/x-gsm');
  c.set('.gtar', 'application/x-tar');
  c.set('.gv', 'text/vnd.graphviz');
  c.set('.gvp', 'text/x-google-video-pointer');
  c.set('.gz', 'application/x-gzip');
  c.set('.h', 'text/x-chdr');
  c.set('.h++', 'text/x-c++hdr');
  c.set('.hdf', 'application/x-hdf');
  c.set('.hh', 'text/x-c++hdr');
  c.set('.hp', 'text/x-c++hdr');
  c.set('.hpgl', 'application/vnd.hp-hpgl');
  c.set('.hpp', 'text/x-c++hdr');
  c.set('.hs', 'text/x-haskell');
  c.set('.htm', 'text/html');
  c.set('.html', 'text/html');
  c.set('.hwp', 'application/x-hwp');
  c.set('.hwt', 'application/x-hwt');
  c.set('.hxx', 'text/x-c++hdr');
  c.set('.ica', 'application/x-ica');
  c.set('.icb', 'image/x-tga');
  c.set('.icns', 'image/x-icns');
  c.set('.ico', 'image/vnd.microsoft.icon');
  c.set('.ics', 'text/calendar');
  c.set('.idl', 'text/x-idl');
  c.set('.ief', 'image/ief');
  c.set('.iff', 'image/x-iff');
  c.set('.ilbm', 'image/x-ilbm');
  c.set('.ime', 'text/x-imelody');
  c.set('.imy', 'text/x-imelody');
  c.set('.ins', 'text/x-tex');
  c.set('.iptables', 'text/x-iptables');
  c.set('.iso', 'application/x-cd-image');
  c.set('.iso9660', 'application/x-cd-image');
  c.set('.it', 'audio/x-it');
  c.set('.j2k', 'image/jp2');
  c.set('.jad', 'text/vnd.sun.j2me.app-descriptor');
  c.set('.jar', 'application/x-java-archive');
  c.set('.java', 'text/x-java');
  c.set('.jng', 'image/x-jng');
  c.set('.jnlp', 'application/x-java-jnlp-file');
  c.set('.jp2', 'image/jp2');
  c.set('.jpc', 'image/jp2');
  c.set('.jpe', 'image/jpeg');
  c.set('.jpeg', 'image/jpeg');
  c.set('.jpf', 'image/jp2');
  c.set('.jpg', 'image/jpeg');
  c.set('.jpr', 'application/x-jbuilder-project');
  c.set('.jpx', 'image/jp2');
  c.set('.js', 'application/javascript');
  c.set('.json', 'application/json');
  c.set('.jsonp', 'application/jsonp');
  c.set('.k25', 'image/x-kodak-k25');
  c.set('.kar', 'audio/midi');
  c.set('.karbon', 'application/x-karbon');
  c.set('.kdc', 'image/x-kodak-kdc');
  c.set('.kdelnk', 'application/x-desktop');
  c.set('.kexi', 'application/x-kexiproject-sqlite3');
  c.set('.kexic', 'application/x-kexi-connectiondata');
  c.set('.kexis', 'application/x-kexiproject-shortcut');
  c.set('.kfo', 'application/x-kformula');
  c.set('.kil', 'application/x-killustrator');
  c.set('.kino', 'application/smil');
  c.set('.kml', 'application/vnd.google-earth.kml+xml');
  c.set('.kmz', 'application/vnd.google-earth.kmz');
  c.set('.kon', 'application/x-kontour');
  c.set('.kpm', 'application/x-kpovmodeler');
  c.set('.kpr', 'application/x-kpresenter');
  c.set('.kpt', 'application/x-kpresenter');
  c.set('.kra', 'application/x-krita');
  c.set('.ksp', 'application/x-kspread');
  c.set('.kud', 'application/x-kugar');
  c.set('.kwd', 'application/x-kword');
  c.set('.kwt', 'application/x-kword');
  c.set('.la', 'application/x-shared-library-la');
  c.set('.latex', 'text/x-tex');
  c.set('.ldif', 'text/x-ldif');
  c.set('.lha', 'application/x-lha');
  c.set('.lhs', 'text/x-literate-haskell');
  c.set('.lhz', 'application/x-lhz');
  c.set('.log', 'text/x-log');
  c.set('.ltx', 'text/x-tex');
  c.set('.lua', 'text/x-lua');
  c.set('.lwo', 'image/x-lwo');
  c.set('.lwob', 'image/x-lwo');
  c.set('.lws', 'image/x-lws');
  c.set('.ly', 'text/x-lilypond');
  c.set('.lyx', 'application/x-lyx');
  c.set('.lz', 'application/x-lzip');
  c.set('.lzh', 'application/x-lha');
  c.set('.lzma', 'application/x-lzma');
  c.set('.lzo', 'application/x-lzop');
  c.set('.m', 'text/x-matlab');
  c.set('.m15', 'audio/x-mod');
  c.set('.m2t', 'video/mpeg');
  c.set('.m3u', 'audio/x-mpegurl');
  c.set('.m3u8', 'audio/x-mpegurl');
  c.set('.m4', 'application/x-m4');
  c.set('.m4a', 'audio/mp4');
  c.set('.m4b', 'audio/x-m4b');
  c.set('.m4v', 'video/mp4');
  c.set('.mab', 'application/x-markaby');
  c.set('.man', 'application/x-troff-man');
  c.set('.mbox', 'application/mbox');
  c.set('.md', 'application/x-genesis-rom');
  c.set('.mdb', 'application/vnd.ms-access');
  c.set('.mdi', 'image/vnd.ms-modi');
  c.set('.me', 'text/x-troff-me');
  c.set('.med', 'audio/x-mod');
  c.set('.metalink', 'application/metalink+xml');
  c.set('.mgp', 'application/x-magicpoint');
  c.set('.mid', 'audio/midi');
  c.set('.midi', 'audio/midi');
  c.set('.mif', 'application/x-mif');
  c.set('.minipsf', 'audio/x-minipsf');
  c.set('.mka', 'audio/x-matroska');
  c.set('.mkv', 'video/x-matroska');
  c.set('.ml', 'text/x-ocaml');
  c.set('.mli', 'text/x-ocaml');
  c.set('.mm', 'text/x-troff-mm');
  c.set('.mmf', 'application/x-smaf');
  c.set('.mml', 'text/mathml');
  c.set('.mng', 'video/x-mng');
  c.set('.mo', 'application/x-gettext-translation');
  c.set('.mo3', 'audio/x-mo3');
  c.set('.moc', 'text/x-moc');
  c.set('.mod', 'audio/x-mod');
  c.set('.mof', 'text/x-mof');
  c.set('.moov', 'video/quicktime');
  c.set('.mov', 'video/quicktime');
  c.set('.movie', 'video/x-sgi-movie');
  c.set('.mp+', 'audio/x-musepack');
  c.set('.mp2', 'video/mpeg');
  c.set('.mp3', 'audio/mpeg');
  c.set('.mp4', 'video/mp4');
  c.set('.mpc', 'audio/x-musepack');
  c.set('.mpe', 'video/mpeg');
  c.set('.mpeg', 'video/mpeg');
  c.set('.mpg', 'video/mpeg');
  c.set('.mpga', 'audio/mpeg');
  c.set('.mpp', 'audio/x-musepack');
  c.set('.mrl', 'text/x-mrml');
  c.set('.mrml', 'text/x-mrml');
  c.set('.mrw', 'image/x-minolta-mrw');
  c.set('.ms', 'text/x-troff-ms');
  c.set('.msi', 'application/x-msi');
  c.set('.msod', 'image/x-msod');
  c.set('.msx', 'application/x-msx-rom');
  c.set('.mtm', 'audio/x-mod');
  c.set('.mup', 'text/x-mup');
  c.set('.mxf', 'application/mxf');
  c.set('.n64', 'application/x-n64-rom');
  c.set('.nb', 'application/mathematica');
  c.set('.nc', 'application/x-netcdf');
  c.set('.nds', 'application/x-nintendo-ds-rom');
  c.set('.nef', 'image/x-nikon-nef');
  c.set('.nes', 'application/x-nes-rom');
  c.set('.nfo', 'text/x-nfo');
  c.set('.not', 'text/x-mup');
  c.set('.nsc', 'application/x-netshow-channel');
  c.set('.nsv', 'video/x-nsv');
  c.set('.o', 'application/x-object');
  c.set('.obj', 'application/x-tgif');
  c.set('.ocl', 'text/x-ocl');
  c.set('.oda', 'application/oda');
  c.set('.odb', 'application/vnd.oasis.opendocument.database');
  c.set('.odc', 'application/vnd.oasis.opendocument.chart');
  c.set('.odf', 'application/vnd.oasis.opendocument.formula');
  c.set('.odg', 'application/vnd.oasis.opendocument.graphics');
  c.set('.odi', 'application/vnd.oasis.opendocument.image');
  c.set('.odm', 'application/vnd.oasis.opendocument.text-master');
  c.set('.odp', 'application/vnd.oasis.opendocument.presentation');
  c.set('.ods', 'application/vnd.oasis.opendocument.spreadsheet');
  c.set('.odt', 'application/vnd.oasis.opendocument.text');
  c.set('.oga', 'audio/ogg');
  c.set('.ogg', 'video/x-theora+ogg');
  c.set('.ogm', 'video/x-ogm+ogg');
  c.set('.ogv', 'video/ogg');
  c.set('.ogx', 'application/ogg');
  c.set('.old', 'application/x-trash');
  c.set('.oleo', 'application/x-oleo');
  c.set('.opml', 'text/x-opml+xml');
  c.set('.ora', 'image/openraster');
  c.set('.orf', 'image/x-olympus-orf');
  c.set('.otc', 'application/vnd.oasis.opendocument.chart-template');
  c.set('.otf', 'application/x-font-otf');
  c.set('.otg', 'application/vnd.oasis.opendocument.graphics-template');
  c.set('.oth', 'application/vnd.oasis.opendocument.text-web');
  c.set('.otp', 'application/vnd.oasis.opendocument.presentation-template');
  c.set('.ots', 'application/vnd.oasis.opendocument.spreadsheet-template');
  c.set('.ott', 'application/vnd.oasis.opendocument.text-template');
  c.set('.owl', 'application/rdf+xml');
  c.set('.oxt', 'application/vnd.openofficeorg.extension');
  c.set('.p', 'text/x-pascal');
  c.set('.p10', 'application/pkcs10');
  c.set('.p12', 'application/x-pkcs12');
  c.set('.p7b', 'application/x-pkcs7-certificates');
  c.set('.p7s', 'application/pkcs7-signature');
  c.set('.pack', 'application/x-java-pack200');
  c.set('.pak', 'application/x-pak');
  c.set('.par2', 'application/x-par2');
  c.set('.pas', 'text/x-pascal');
  c.set('.patch', 'text/x-patch');
  c.set('.pbm', 'image/x-portable-bitmap');
  c.set('.pcd', 'image/x-photo-cd');
  c.set('.pcf', 'application/x-cisco-vpn-settings');
  c.set('.pcf.gz', 'application/x-font-pcf');
  c.set('.pcf.z', 'application/x-font-pcf');
  c.set('.pcl', 'application/vnd.hp-pcl');
  c.set('.pcx', 'image/x-pcx');
  c.set('.pdb', 'chemical/x-pdb');
  c.set('.pdc', 'application/x-aportisdoc');
  c.set('.pdf', 'application/pdf');
  c.set('.pdf.bz2', 'application/x-bzpdf');
  c.set('.pdf.gz', 'application/x-gzpdf');
  c.set('.pef', 'image/x-pentax-pef');
  c.set('.pem', 'application/x-x509-ca-cert');
  c.set('.perl', 'application/x-perl');
  c.set('.pfa', 'application/x-font-type1');
  c.set('.pfb', 'application/x-font-type1');
  c.set('.pfx', 'application/x-pkcs12');
  c.set('.pgm', 'image/x-portable-graymap');
  c.set('.pgn', 'application/x-chess-pgn');
  c.set('.pgp', 'application/pgp-encrypted');
  c.set('.php', 'application/x-php');
  c.set('.php3', 'application/x-php');
  c.set('.php4', 'application/x-php');
  c.set('.pict', 'image/x-pict');
  c.set('.pict1', 'image/x-pict');
  c.set('.pict2', 'image/x-pict');
  c.set('.pickle', 'application/python-pickle');
  c.set('.pk', 'application/x-tex-pk');
  c.set('.pkipath', 'application/pkix-pkipath');
  c.set('.pkr', 'application/pgp-keys');
  c.set('.pl', 'application/x-perl');
  c.set('.pla', 'audio/x-iriver-pla');
  c.set('.pln', 'application/x-planperfect');
  c.set('.pls', 'audio/x-scpls');
  c.set('.pm', 'application/x-perl');
  c.set('.png', 'image/png');
  c.set('.pnm', 'image/x-portable-anymap');
  c.set('.pntg', 'image/x-macpaint');
  c.set('.po', 'text/x-gettext-translation');
  c.set('.por', 'application/x-spss-por');
  c.set('.pot', 'text/x-gettext-translation-template');
  c.set('.ppm', 'image/x-portable-pixmap');
  c.set('.pps', 'application/vnd.ms-powerpoint');
  c.set('.ppt', 'application/vnd.ms-powerpoint');
  c.set(
    '.pptm',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  );
  c.set(
    '.pptx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  );
  c.set('.ppz', 'application/vnd.ms-powerpoint');
  c.set('.prc', 'application/x-palm-database');
  c.set('.ps', 'application/postscript');
  c.set('.ps.bz2', 'application/x-bzpostscript');
  c.set('.ps.gz', 'application/x-gzpostscript');
  c.set('.psd', 'image/vnd.adobe.photoshop');
  c.set('.psf', 'audio/x-psf');
  c.set('.psf.gz', 'application/x-gz-font-linux-psf');
  c.set('.psflib', 'audio/x-psflib');
  c.set('.psid', 'audio/prs.sid');
  c.set('.psw', 'application/x-pocket-word');
  c.set('.pw', 'application/x-pw');
  c.set('.py', 'text/x-python');
  c.set('.pyc', 'application/x-python-bytecode');
  c.set('.pyo', 'application/x-python-bytecode');
  c.set('.qif', 'image/x-quicktime');
  c.set('.qt', 'video/quicktime');
  c.set('.qtif', 'image/x-quicktime');
  c.set('.qtl', 'application/x-quicktime-media-link');
  c.set('.qtvr', 'video/quicktime');
  c.set('.ra', 'audio/vnd.rn-realaudio');
  c.set('.raf', 'image/x-fuji-raf');
  c.set('.ram', 'application/ram');
  c.set('.rar', 'application/x-rar');
  c.set('.ras', 'image/x-cmu-raster');
  c.set('.raw', 'image/x-panasonic-raw');
  c.set('.rax', 'audio/vnd.rn-realaudio');
  c.set('.rb', 'application/x-ruby');
  c.set('.rdf', 'application/rdf+xml');
  c.set('.rdfs', 'application/rdf+xml');
  c.set('.reg', 'text/x-ms-regedit');
  c.set('.rej', 'application/x-reject');
  c.set('.rgb', 'image/x-rgb');
  c.set('.rle', 'image/rle');
  c.set('.rm', 'application/vnd.rn-realmedia');
  c.set('.rmj', 'application/vnd.rn-realmedia');
  c.set('.rmm', 'application/vnd.rn-realmedia');
  c.set('.rms', 'application/vnd.rn-realmedia');
  c.set('.rmvb', 'application/vnd.rn-realmedia');
  c.set('.rmx', 'application/vnd.rn-realmedia');
  c.set('.roff', 'text/troff');
  c.set('.rp', 'image/vnd.rn-realpix');
  c.set('.rpm', 'application/x-rpm');
  c.set('.rss', 'application/rss+xml');
  c.set('.rt', 'text/vnd.rn-realtext');
  c.set('.rtf', 'application/rtf');
  c.set('.rtx', 'text/richtext');
  c.set('.rv', 'video/vnd.rn-realvideo');
  c.set('.rvx', 'video/vnd.rn-realvideo');
  c.set('.s3m', 'audio/x-s3m');
  c.set('.sam', 'application/x-amipro');
  c.set('.sami', 'application/x-sami');
  c.set('.sav', 'application/x-spss-sav');
  c.set('.scm', 'text/x-scheme');
  c.set('.sda', 'application/vnd.stardivision.draw');
  c.set('.sdc', 'application/vnd.stardivision.calc');
  c.set('.sdd', 'application/vnd.stardivision.impress');
  c.set('.sdp', 'application/sdp');
  c.set('.sds', 'application/vnd.stardivision.chart');
  c.set('.sdw', 'application/vnd.stardivision.writer');
  c.set('.sgf', 'application/x-go-sgf');
  c.set('.sgi', 'image/x-sgi');
  c.set('.sgl', 'application/vnd.stardivision.writer');
  c.set('.sgm', 'text/sgml');
  c.set('.sgml', 'text/sgml');
  c.set('.sh', 'application/x-shellscript');
  c.set('.shar', 'application/x-shar');
  c.set('.shn', 'application/x-shorten');
  c.set('.siag', 'application/x-siag');
  c.set('.sid', 'audio/prs.sid');
  c.set('.sik', 'application/x-trash');
  c.set('.sis', 'application/vnd.symbian.install');
  c.set('.sisx', 'x-epoc/x-sisx-app');
  c.set('.sit', 'application/x-stuffit');
  c.set('.siv', 'application/sieve');
  c.set('.sk', 'image/x-skencil');
  c.set('.sk1', 'image/x-skencil');
  c.set('.skr', 'application/pgp-keys');
  c.set('.slk', 'text/spreadsheet');
  c.set('.smaf', 'application/x-smaf');
  c.set('.smc', 'application/x-snes-rom');
  c.set('.smd', 'application/vnd.stardivision.mail');
  c.set('.smf', 'application/vnd.stardivision.math');
  c.set('.smi', 'application/x-sami');
  c.set('.smil', 'application/smil');
  c.set('.sml', 'application/smil');
  c.set('.sms', 'application/x-sms-rom');
  c.set('.snd', 'audio/basic');
  c.set('.so', 'application/x-sharedlib');
  c.set('.spc', 'application/x-pkcs7-certificates');
  c.set('.spd', 'application/x-font-speedo');
  c.set('.spec', 'text/x-rpm-spec');
  c.set('.spl', 'application/x-shockwave-flash');
  c.set('.spx', 'audio/x-speex');
  c.set('.sql', 'text/x-sql');
  c.set('.sr2', 'image/x-sony-sr2');
  c.set('.src', 'application/x-wais-source');
  c.set('.srf', 'image/x-sony-srf');
  c.set('.srt', 'application/x-subrip');
  c.set('.ssa', 'text/x-ssa');
  c.set('.stc', 'application/vnd.sun.xml.calc.template');
  c.set('.std', 'application/vnd.sun.xml.draw.template');
  c.set('.sti', 'application/vnd.sun.xml.impress.template');
  c.set('.stm', 'audio/x-stm');
  c.set('.stw', 'application/vnd.sun.xml.writer.template');
  c.set('.sty', 'text/x-tex');
  c.set('.sub', 'text/x-subviewer');
  c.set('.sun', 'image/x-sun-raster');
  c.set('.sv4cpio', 'application/x-sv4cpio');
  c.set('.sv4crc', 'application/x-sv4crc');
  c.set('.svg', 'image/svg+xml');
  c.set('.svgz', 'image/svg+xml-compressed');
  c.set('.swf', 'application/x-shockwave-flash');
  c.set('.sxc', 'application/vnd.sun.xml.calc');
  c.set('.sxd', 'application/vnd.sun.xml.draw');
  c.set('.sxg', 'application/vnd.sun.xml.writer.global');
  c.set('.sxi', 'application/vnd.sun.xml.impress');
  c.set('.sxm', 'application/vnd.sun.xml.math');
  c.set('.sxw', 'application/vnd.sun.xml.writer');
  c.set('.sylk', 'text/spreadsheet');
  c.set('.t', 'text/troff');
  c.set('.t2t', 'text/x-txt2tags');
  c.set('.tar', 'application/x-tar');
  c.set('.tar.bz', 'application/x-bzip-compressed-tar');
  c.set('.tar.bz2', 'application/x-bzip-compressed-tar');
  c.set('.tar.gz', 'application/x-compressed-tar');
  c.set('.tar.lzma', 'application/x-lzma-compressed-tar');
  c.set('.tar.lzo', 'application/x-tzo');
  c.set('.tar.xz', 'application/x-xz-compressed-tar');
  c.set('.tar.z', 'application/x-tarz');
  c.set('.tbz', 'application/x-bzip-compressed-tar');
  c.set('.tbz2', 'application/x-bzip-compressed-tar');
  c.set('.tcl', 'text/x-tcl');
  c.set('.tex', 'text/x-tex');
  c.set('.texi', 'text/x-texinfo');
  c.set('.texinfo', 'text/x-texinfo');
  c.set('.tga', 'image/x-tga');
  c.set('.tgz', 'application/x-compressed-tar');
  c.set('.theme', 'application/x-theme');
  c.set('.themepack', 'application/x-windows-themepack');
  c.set('.tif', 'image/tiff');
  c.set('.tiff', 'image/tiff');
  c.set('.tk', 'text/x-tcl');
  c.set('.tlz', 'application/x-lzma-compressed-tar');
  c.set('.tnef', 'application/vnd.ms-tnef');
  c.set('.tnf', 'application/vnd.ms-tnef');
  c.set('.toc', 'application/x-cdrdao-toc');
  c.set('.torrent', 'application/x-bittorrent');
  c.set('.tpic', 'image/x-tga');
  c.set('.tr', 'text/troff');
  c.set('.ts', 'application/x-linguist');
  c.set('.tsv', 'text/tab-separated-values');
  c.set('.tta', 'audio/x-tta');
  c.set('.ttc', 'application/x-font-ttf');
  c.set('.ttf', 'application/x-font-ttf');
  c.set('.ttx', 'application/x-font-ttx');
  c.set('.txt', 'text/plain');
  c.set('.txz', 'application/x-xz-compressed-tar');
  c.set('.tzo', 'application/x-tzo');
  c.set('.ufraw', 'application/x-ufraw');
  c.set('.ui', 'application/x-designer');
  c.set('.uil', 'text/x-uil');
  c.set('.ult', 'audio/x-mod');
  c.set('.uni', 'audio/x-mod');
  c.set('.uri', 'text/x-uri');
  c.set('.url', 'text/x-uri');
  c.set('.ustar', 'application/x-ustar');
  c.set('.vala', 'text/x-vala');
  c.set('.vapi', 'text/x-vala');
  c.set('.vcf', 'text/directory');
  c.set('.vcs', 'text/calendar');
  c.set('.vct', 'text/directory');
  c.set('.vda', 'image/x-tga');
  c.set('.vhd', 'text/x-vhdl');
  c.set('.vhdl', 'text/x-vhdl');
  c.set('.viv', 'video/vivo');
  c.set('.vivo', 'video/vivo');
  c.set('.vlc', 'audio/x-mpegurl');
  c.set('.vob', 'video/mpeg');
  c.set('.voc', 'audio/x-voc');
  c.set('.vor', 'application/vnd.stardivision.writer');
  c.set('.vst', 'image/x-tga');
  c.set('.wav', 'audio/x-wav');
  c.set('.wax', 'audio/x-ms-asx');
  c.set('.wb1', 'application/x-quattropro');
  c.set('.wb2', 'application/x-quattropro');
  c.set('.wb3', 'application/x-quattropro');
  c.set('.wbmp', 'image/vnd.wap.wbmp');
  c.set('.wcm', 'application/vnd.ms-works');
  c.set('.wdb', 'application/vnd.ms-works');
  c.set('.webm', 'video/webm');
  c.set('.wk1', 'application/vnd.lotus-1-2-3');
  c.set('.wk3', 'application/vnd.lotus-1-2-3');
  c.set('.wk4', 'application/vnd.lotus-1-2-3');
  c.set('.wks', 'application/vnd.ms-works');
  c.set('.wma', 'audio/x-ms-wma');
  c.set('.wmf', 'image/x-wmf');
  c.set('.wml', 'text/vnd.wap.wml');
  c.set('.wmls', 'text/vnd.wap.wmlscript');
  c.set('.wmv', 'video/x-ms-wmv');
  c.set('.wmx', 'audio/x-ms-asx');
  c.set('.wp', 'application/vnd.wordperfect');
  c.set('.wp4', 'application/vnd.wordperfect');
  c.set('.wp5', 'application/vnd.wordperfect');
  c.set('.wp6', 'application/vnd.wordperfect');
  c.set('.wpd', 'application/vnd.wordperfect');
  c.set('.wpg', 'application/x-wpg');
  c.set('.wpl', 'application/vnd.ms-wpl');
  c.set('.wpp', 'application/vnd.wordperfect');
  c.set('.wps', 'application/vnd.ms-works');
  c.set('.wri', 'application/x-mswrite');
  c.set('.wrl', 'model/vrml');
  c.set('.wv', 'audio/x-wavpack');
  c.set('.wvc', 'audio/x-wavpack-correction');
  c.set('.wvp', 'audio/x-wavpack');
  c.set('.wvx', 'audio/x-ms-asx');
  c.set('.x3f', 'image/x-sigma-x3f');
  c.set('.xac', 'application/x-gnucash');
  c.set('.xbel', 'application/x-xbel');
  c.set('.xbl', 'application/xml');
  c.set('.xbm', 'image/x-xbitmap');
  c.set('.xcf', 'image/x-xcf');
  c.set('.xcf.bz2', 'image/x-compressed-xcf');
  c.set('.xcf.gz', 'image/x-compressed-xcf');
  c.set('.xhtml', 'application/xhtml+xml');
  c.set('.xi', 'audio/x-xi');
  c.set('.xla', 'application/vnd.ms-excel');
  c.set('.xlc', 'application/vnd.ms-excel');
  c.set('.xld', 'application/vnd.ms-excel');
  c.set('.xlf', 'application/x-xliff');
  c.set('.xliff', 'application/x-xliff');
  c.set('.xll', 'application/vnd.ms-excel');
  c.set('.xlm', 'application/vnd.ms-excel');
  c.set('.xls', 'application/vnd.ms-excel');
  c.set(
    '.xlsm',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  );
  c.set(
    '.xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  );
  c.set('.xlt', 'application/vnd.ms-excel');
  c.set('.xlw', 'application/vnd.ms-excel');
  c.set('.xm', 'audio/x-xm');
  c.set('.xmf', 'audio/x-xmf');
  c.set('.xmi', 'text/x-xmi');
  c.set('.xml', 'application/xml');
  c.set('.xpm', 'image/x-xpixmap');
  c.set('.xps', 'application/vnd.ms-xpsdocument');
  c.set('.xsl', 'application/xml');
  c.set('.xslfo', 'text/x-xslfo');
  c.set('.xslt', 'application/xml');
  c.set('.xspf', 'application/xspf+xml');
  c.set('.xul', 'application/vnd.mozilla.xul+xml');
  c.set('.xwd', 'image/x-xwindowdump');
  c.set('.xyz', 'chemical/x-pdb');
  c.set('.xz', 'application/x-xz');
  c.set('.w2p', 'application/w2p');
  c.set('.z', 'application/x-compress');
  c.set('.zabw', 'application/x-abiword');
  c.set('.zip', 'application/zip');
  const extension = getExtension(filename);
  if (extension && extension.length > 0) {
    if (c.has(extension.toLowerCase())) {
      return c.get(extension.toLowerCase());
    }
  }
  return 'text/plain';
};
